import React from 'react'
import { CommandEmpty } from 'cmdk'
import { Box, BoxProps } from 'rebass/styled-components'

export const SmartSelectEmpty = ({ children, sx, ...props }: BoxProps): JSX.Element => {
  return (
    <CommandEmpty>
      <Box sx={{ m: '6px 20px', ...sx }} {...props}>
        {children}
      </Box>
    </CommandEmpty>
  )
}
